import React, { Component } from 'react'
import { connect } from 'react-redux'
import { dispatch } from '../../jsCore/application/appStore'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { recommendedListReducers } from '../../jsCore/store/recommendedVideos/recommendedVideos.reducers'
import {
  recievedRecommedationsAction,
  setPlaylistId,
} from '../../jsCore/store/recommendedVideos/recommendedVideos.actions'
import { RecommendedHeader } from './components/recommendedHeader'
import { RecommendedList } from './components/recommendedList'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'

const componentName = 'recommendedVideos'
const stateKey = componentName

export class RecommendedVideosComponent extends Component {
  componentWillMount() {
    const { playlistId } = this.props.options.dataset
    dispatch(setPlaylistId(playlistId))
  }

  render() {
    const { recommendedItems: itemsList, isInitialized, recievedError } = this.props
    const {
      analyticsEventAction,
      analyticsEventCategory,
      analyticsEventLabel,
      analyticsEventValue,
    } = this.props.options.dataset
    const recommendedVideosProps = {
      itemsList,
      isInitialized,
      recievedError,
      analyticsEventAction,
      analyticsEventCategory,
      analyticsEventLabel,
      analyticsEventValue,
    }
    return recievedError
      ? <noscript />
      : <div className="recommended-videos">
          <RecommendedHeader />
          <RecommendedList {...recommendedVideosProps} />
        </div>
  }
}

function mapStateToProps(state) {
  const { isInitialized, recommendedItems, recievedError } = state[stateKey]
  return {
    isInitialized,
    recommendedItems,
    recievedError,
  }
}

const recommendedVideosContainer = {
  name: componentName,
  stateKey,
  component: connect(mapStateToProps, { recievedRecommedationsAction })(RecommendedVideosComponent),
  reducer: recommendedListReducers,
}

function mountRecommendedVideos() {
  return reduxMount({
    [MOUNT_POINTS.RECOMMENDED_VIDEOS_CONTAINER]: recommendedVideosContainer,
  })
}

export default function initRecommendedVideos() {
  mountRecommendedVideos()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedVideos/recommendedVideos.container.js